<template>
    <footer class="footer py-3 ">
        <div class="container-fluid">
            <div class="row align-items-center justify-content-lg-between">
                <div class="col-lg-12 mb-0">
                    <div class="text-center text-sm text-muted">
                        MiGPS © {{ new Date().getFullYear() }}
                    </div>
                </div>
            </div>
        </div>
    </footer>
</template>

<script>
export default {
    name: "AppFooter",
};
</script>

<style scoped>
footer {
    width: 100%;
}
</style>